export const title = 'Post-download conversion';

Percentage of downloads that resulted in an in-app purchase within 24 hours after download.
